/**
 * Smart Redirect Component
 *
 * Redirects users based on authentication status:
 * - Authenticated users → /home
 * - Unauthenticated users → /welcome (landing page)
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export function SmartRedirect() {
  const { user, loading } = useAuth();

  // Show nothing while checking auth state
  if (loading) {
    return null;
  }

  // Redirect authenticated users to home, others to welcome page
  if (user) {
    return <Navigate to="/home" replace />;
  }

  return <Navigate to="/welcome" replace />;
}
